<template>
  <div class="reQuestion_detail_container">问答</div>
</template>
<script>
export default {
  name: "ReQuestionDetail",
  data() {
    return {};
  },
  methods: {},
  created() {},
};
</script>
<style scoped lang="scss">
.reQuestion_detail_container {
  width: 100%;
  height: 100%;
  padding: 0px;
  overflow-x: hidden;
  overflow-y: auto;
}
</style>